/** --- Получение товаров с сервера --- */
export async function fetchProductsFromSheet() {
  const res = await fetch("/api/products");
  if (!res.ok) throw new Error("Ошибка загрузки товаров");
  return res.json();
}

/** --- Создание нового заказа --- */
export async function createOrder(orderItems = []) {
  if (orderItems.length === 0) return;

  const parsePrice = (priceStr) => {
    if (!priceStr) return 0;
    const cleaned = priceStr.toString().replace(/\s|₽/g, "");
    const num = parseFloat(cleaned);
    return isNaN(num) ? 0 : num;
  };

  const totalPrice = orderItems.reduce(
    (sum, item) => sum + parsePrice(item["Цена"]) * (item.quantity || 1),
    0
  );

  const itemsPayload = orderItems.map((item) => ({
    name: item["Товар"],
    quantity: item.quantity || 1,
    price: parsePrice(item["Цена"]),
  }));

  const res = await fetch("/api/create-payment", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      amount: totalPrice,
      items: itemsPayload,
    }),
  });

  if (!res.ok) {
    const text = await res.text();
    throw new Error("Ошибка при создании заказа: " + text);
  }
}
